import { useEffect } from "react";

/**
 * Blocks scrolling on a specific element by ID or defaults to the body.
 *
 * @param {boolean} shouldBlock - Whether to block scrolling.
 * @param {string} [elementId] - Optional element ID to block scrolling on.
 */
const useBlockScroll = (shouldBlock, elementId,) => {
  useEffect(() => {
    const el = elementId
      ? document.getElementById(elementId)
      : document.body;

    if (!el) return;

    if (shouldBlock) {
      el.style.overflow = "hidden";
    } else {
      el.style.overflow = "";
    }

    return () => {
      if (el) {
        el.style.overflow = "";
      }
    };
  }, [shouldBlock, elementId]);
};

export default useBlockScroll;
